export default __webpack_public_path__ + "5d42b4e60858731e7b6504400f7e3d8e.ttf";